import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { useTranslation } from "react-i18next";
import { PasswordChangeSuccessfullStyled } from "./styled";

const PasswordChangeSuccessfull = ({ theme_standard }) => {
  const { t } = useTranslation(["common"]);
  const customClass = cx({
    theme_standard: theme_standard,
  });
  return (
    <PasswordChangeSuccessfullStyled className={customClass}>
      <div className="password_change_successfull_title">{t("Password changed successfully!", { ns: "common" })}</div>
      <div className="password_change_successfull_subtitle">“กำลังพาคุณกลับไปหน้าล็อกอิน”</div>
    </PasswordChangeSuccessfullStyled>
  );
};

PasswordChangeSuccessfull.propTypes = {};

export default PasswordChangeSuccessfull;
